import { Action } from '@ngrx/store';
import * as ActivitiesOfDailyLivingResultActions from '../actions/activitiesOfDailyLiving.action';

export type Actions = ActivitiesOfDailyLivingResultActions.Actions;

export function ActivitiesOfDailyLivingReducer(state: any[] = [],
    action: ActivitiesOfDailyLivingResultActions.Actions) {
    switch (action.type) {
        case ActivitiesOfDailyLivingResultActions.ADD_ACTIVITIESOFDAILYLIVING_RESULT:
            return [...state, action.payload];

        // Add this case:
        case ActivitiesOfDailyLivingResultActions.REMOVE_ACTIVITIESOFDAILYLIVING_RESULT:
            return [...state].splice(action.payload, 1);
        default:
            return state;
    }
}

